<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.43994 3.45123H7.89212C7.7269 4.11706 7.7269 4.78289 7.7269 5.44871C7.89211 7.9468 9.54429 14.6051 9.54429 14.6051L12.0225 4.11789L14.666 14.2721C14.666 14.2721 16.3182 5.28349 16.3182 4.61767C16.3182 4.11788 15.9878 3.78497 15.6573 3.45206H21.4399C20.6139 4.11788 20.1182 5.11662 19.7878 6.11536C19.2921 8.11284 17.4747 18.1011 17.4747 18.7669C17.4747 19.4327 17.8052 20.0985 18.1356 20.5983H12.8486C13.0139 20.0985 13.0139 19.5988 13.0139 19.0998C13.0139 18.1011 12.1878 13.7732 12.1878 13.7732C12.1878 13.7732 11.0312 18.2671 11.0312 19.0998C11.0312 19.5996 11.1965 20.0994 11.3617 20.5983H5.90951C5.90951 20.5983 6.90081 19.7656 6.90081 19.0998C6.73559 17.1023 3.9269 6.44828 3.76168 5.61641C3.76168 4.78371 3.26603 3.95102 2.43994 3.45123Z"
            fill="url(#paint0_linear_5156_467)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5156_467"
                x1="11.9398"
                y1="20.5984"
                x2="11.9398"
                y2="3.45123"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#3F414B" />
                <stop offset="1" stop-color="#6F727E" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
